import React from "react";
import { Link } from "react-router-dom";
import { Target, CalendarDays, MessageCircle, HeartHandshake, Smartphone } from "lucide-react";
import { externalLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0a0a0c]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-[#ff2e4d]">
                <Target className="h-6 w-6 text-white" strokeWidth={2.4} />
              </span>
              <span className="font-condensed text-2xl text-white tracking-wide">BULLS ON PARADE</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400">
              Ontario’s darts content hub — coaching, a youth academy, pro-shop supplies, and the
              sponsors keeping the local scene thrown, all under one roof.
            </p>
            <a
              href={externalLinks.gofundme}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#ff2e4d] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#e01f3c] transition-colors"
            >
              <HeartHandshake className="h-4 w-4" /> Support on GoFundMe
            </a>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white">Explore</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/" className="hover:text-[#ff2e4d] transition-colors">Home</Link></li>
              <li><Link to="/programs" className="hover:text-[#ff2e4d] transition-colors">Programs & Pro Shop</Link></li>
              <li><Link to="/programs#coaching" className="hover:text-[#ff2e4d] transition-colors">Adult Coaching</Link></li>
              <li><Link to="/programs#youth-academy" className="hover:text-[#ff2e4d] transition-colors">Youth Academy</Link></li>
              <li><Link to="/programs#sponsors" className="hover:text-[#ff2e4d] transition-colors">Sponsors</Link></li>
              <li><Link to="/contact" className="hover:text-[#ff2e4d] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white">Stay in the game</h4>
            <ul className="mt-4 space-y-3 text-sm text-zinc-400">
              <li>
                <Link to="/tournament-calendars" className="inline-flex items-center gap-2 hover:text-[#ff2e4d] transition-colors">
                  <CalendarDays className="h-4 w-4" /> Tournament Calendars
                </Link>
              </li>
              <li>
                <a href={externalLinks.discord} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#ff2e4d] transition-colors">
                  <MessageCircle className="h-4 w-4" /> Community Chat
                </a>
              </li>
              <li>
                <a href={externalLinks.companionApp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#ff2e4d] transition-colors">
                  <Smartphone className="h-4 w-4" /> Bulls on Parade Darts
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Bulls On Parade. Ontario, Canada.</p>
          <div className="flex items-center gap-4">
            <Link to="/admin" className="text-xs text-zinc-600 hover:text-[#ff2e4d] transition-colors">Manage shop</Link>
            <p className="text-xs text-zinc-600">Where Ontario aims true.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
